import gql from 'graphql-tag'
import { type Role, type Permission } from 'legacy/common/types'
import { type Flipper } from 'legacy/contexts/flipper/FlipperContext'
import { useRetailersQuery } from 'legacy/apollo/clientHooks'
import { type QueryHookOptions } from '@apollo/react-hooks'

export const FETCH_CURRENT_PARTNER_USER_QUERY = gql`
  query currentPartnerUser {
    currentPartnerUser {
      uuid
      email
      firstName
      lastName
      roles
      flippers
      permissions
      partners {
        id
      }
      warehouses {
        id
      }
    }
  }
`

export interface CurrentPartnerUser {
  uuid: string
  email: string
  firstName: string
  lastName: string
  roles: Role[]
  flippers: Flipper[]
  permissions: Permission[]
  partners: { id: string }[]
  warehouses: { id: string }[]
}

export interface CurrentPartnerUserData {
  currentPartnerUser: CurrentPartnerUser
}

export const useFetchCurrentPartnerUser = (options: QueryHookOptions = {}) => {
  const { data, loading, error } = useRetailersQuery<CurrentPartnerUserData, {}>(
    FETCH_CURRENT_PARTNER_USER_QUERY,
    options
  )

  const currentPartnerUser = data && data.currentPartnerUser

  return {
    currentPartnerUser,
    loading,
    error,
  }
}
